// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3z3GH","right":"Footer_right__1u5lR","buttons":"Footer_buttons__2uwLU"};